import React, { useState } from 'react';
import cx from 'classnames';
import Icon from '@cloudscape-design/components/icon';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Button, ButtonProps } from '@cloudscape-design/components';

export const CopyToClipboardButton = ({
  icon,
  data,
  label = 'Copy to Clipboard',
  variant = 'primary',
}: {
  icon?: string;
  data: string;
  label?: string;
  variant?: ButtonProps.Variant;
}) => {
  const [copiedToClipboard, setCopiedToClipboard] = useState<boolean>(false);

  return (
    <span className={cx('copy-button', { 'copy-button--icon': icon })}>
      {copiedToClipboard && (
        <div className="copy-to-clipboard-notice">Copied</div>
      )}
      <CopyToClipboard
        text={data}
        onCopy={() => {
          setCopiedToClipboard(true);
          setTimeout(() => {
            setCopiedToClipboard(false);
          }, 1000);
        }}
      >
        <Button disabled={!data} variant={variant}>
          {icon ? (
            <>
              <Icon name="copy" size="small" />
              <span className="copy-to-clipboard__icon-label">Copy</span>
            </>
          ) : (
            label
          )}
        </Button>
      </CopyToClipboard>
    </span>
  );
};
